import { useEffect, useState, useLayoutEffect } from "react";
import * as global from '../data/global';
import { MuiMaterials } from '../@index.js';
import { createApiEndpoint } from '../index.js';
import { createTheme } from '@mui/material/styles';
import ReportTemperatureComparison from "./ReportTempertureComparison";
//import Dayjs from 'dayjs';

const theme = MuiMaterials.createTheme({
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "#f4cc8e",
                    fontSize: "18px",
                },
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    background: "#2d2d2d",
                    color: "rgb(244, 204, 142)",
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeMedium: {
                    color: "rgb(244, 204, 142)"
                }
            }
        },
    },
});
const datePickerTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    background: "#2d2d2d",
                    color: "rgb(244, 204, 142)",
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeMedium: {
                    color: "rgb(244, 204, 142)"
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    background: "#2d2d2d",
                    color: "rgb(244, 204, 142)"
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    background: "#2d2d2d",
                    color: "rgb(244, 204, 142)"
                }
            }
        }
    }
});

const ReportTemparatureComparison = () => {
    const [value, setValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleViewReportClick = () => {
        setLoading(true);
        const htask = () => {
            return createApiEndpoint().fetchTemperatureHistoryReport("compressed",
                [new Date()],
                global.gw.selectedSite.temperatureComparison.daysToCompare,
                global.gw.selectedSite.temperatureComparison.plus,
                global.gw.selectedSite.temperatureComparison.minus);
        };
        htask().then((response) => {
            if (response) {
                var base64Bytes = global.base64StringToArrayBuffer(response.data.fetchTemperatureHistoryReport.value);
                //let byteArray = global.stringToUTF16Bytes(decompressed);
                const blob = new Blob([base64Bytes], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            }
            else {
                //navigate("/sites");
            }
            setLoading(false);
        }).catch(function (error) {
            if (error.message &&
                error.message.endsWith("401") &&
                global.gw.token &&
                global.gw.auth) {
                createApiEndpoint(global.Endpoints.GrainWave).fetchRenew();
            }
            else {
                //clearToken();
                //navigate("/", { replace: true });
                //window.scrollTo(0, 0);
            }
            setLoading(false);
        });
    };
    let columnCount = 0;
    let pageWidth = 0;

    useEffect(() => {
        let outletContainer = window.document.getElementById("outletContainer").getBoundingClientRect();
        let reportWindow = window.document.getElementsByClassName("reportWindow")[0];
        if (reportWindow) {
            let reportWindowRect = reportWindow.getBoundingClientRect();
            reportWindow.style.left = "2px";
            reportWindow.style.top = `${outletContainer.top}px`;
            reportWindow.style.height = `${reportWindowRect.height - outletContainer.top}px`;
            reportWindow.style.bottom = "2px";
            //reportWindow.style.width = `${outletContainer.width - 3}px`;
            reportWindow.style.display = "none";
        }
    });

    useLayoutEffect(() => {
        if (columnCount > 0) {
            for (let i = 0; i < columnCount; i++) {
                let columnMaxWidth = 20;
                let columnElements = window.document.querySelectorAll(`[class*='reportColumn'][columnIndex='${i}']`);
                for (let c = 0; c < columnElements.length; c++) {
                    let columnElement = columnElements[c];
                    let width = columnElement.offsetWidth + 6;
                    if (width > columnMaxWidth) {
                        columnMaxWidth = width;
                    }
                }
                for (let c = 0; c < columnElements.length; c++) {
                    let columnElement = columnElements[c];
                    columnElement.style.width = `${columnMaxWidth}px`;
                }
                pageWidth += columnMaxWidth;
            }
            pageWidth += 5;
            let reportWindow = window.document.getElementsByClassName("reportWindow")[0];
            if (reportWindow) {
                reportWindow.style.width = `${pageWidth}px`;
            }
        }
    }, []);

    const renderTitle = (title) => (
        <MuiMaterials.Box
            sx={{
                textAlign: "center",
                margin: "30px 5px 0px 5px",
                fontSize: "30px",
                fontWeight: "600",
            }}
        >
            {title}
        </MuiMaterials.Box>
    );

    const renderSubTitle = (subTitle) => (
        <MuiMaterials.Box
            sx={{
                textAlign: "center",
                margin: "-5px 5px 5px 5px",
                fontSize: "11px",
                fontWeight: "900",
            }}
        >
            {subTitle}
        </MuiMaterials.Box>
    );

    const renderInfoTitle = (infoTitle) => (
        <MuiMaterials.Box
            sx={{
                textAlign: "center",
                margin: "-5px 5px 10px 5px",
                fontSize: "8px",
                fontWeight: "600",
            }}
        >
            {infoTitle}
        </MuiMaterials.Box>
    );

    const testHeaderData = [
        "Cable",
        "Date Read",
        "T1",
        "T2",
        "T3",
        "T4",
        "T5",
        "T6",
        "T7",
        "T8",
        "T9",
        "T10",
        "T11",
        "T12",
        "T13",
        "T14",
        "T15",
        "T16",
        "T17",
        "T18",
        "T19",
        "T20",
        "T21",
    ]

    const renderDataHeader = (headerData) => (
        <MuiMaterials.Box
            sx={{
                display: "flex",
                //justifyContent: "space-evenly",
                textAlign: "center",
                margin: "5px 5px 0px 5px",
                fontSize: "8px",
                fontWeight: "900",
            }}
        >
            {headerData.map((x, i) => { 
                if (columnCount <= i) {
                    columnCount++;
                }
                return (<MuiMaterials.Box
                    className="reportHeader reportColumn"
                    columnIndex={i}
                    //key={`${x}_${i}`}
                    sx={{
                        //minWidth: "50px",
                    }}
                 >
                    {x}
                </MuiMaterials.Box>
             )})}
        </MuiMaterials.Box>
    );

    const renderGroupBox = (boxTitle) => (
        <MuiMaterials.Box
            sx={{
                display: "flex",
                justifyContent: "space-evenly",
                textAlign: "center",
                margin: "0px 5px",
                fontSize: "12px",
                fontWeight: "900",
                borderStyle: "solid",
                borderWidth: "0.5px",
                borderColor: "black",
            }}
        >
            {boxTitle}
        </MuiMaterials.Box>
    );

    const testGroupData = [
        "Bin 313-1",
        "09/25/24 07:05 AM",
        "81",
        "82",
        83,
        83,
        82,
        82,
        83,
        83,
        83,
        83,
        83,
        84,
        83,
        76,
        76,
        "79",
        "",
        "",
        "",
        "",
        "",
    ];

    const renderGroupData = (groupData) => (
        <MuiMaterials.Box
            sx={{
                display: "flex",
                //justifyContent: "space-evenly",
                textAlign: "center",
                margin: "0px 5px",
                fontSize: "8px",
                fontWeight: "900",
            }}
        >
            {groupData.map((x,i) => (
                <MuiMaterials.Box
                    className="reportCell reportColumn"
                    columnIndex={i}
                    sx={{
                        //minWidth: "50px",
                    }}
                >
                    {x}
                </MuiMaterials.Box>
            ))}
        </MuiMaterials.Box>
    );

    return (
        <div>
            <MuiMaterials.Box
                className="reportWindow"
                sx={{
                    //display: "none",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "stretch",
                    overflowX: "hidden",
                    paddingBottom: "4px",
                    height: "-webkit-fill-available",
                    borderStyle: "solid",
                    borderColor: "#121212",
                    borderWidth: "0.5px",
                    borderRadius: "4px",
                    resize: "both",
                    cursor: "default",
                    background: "white",
                    zIndex: "2",
                }}
            >
                {renderTitle("Comparison Report")}
                {renderSubTitle("Producers Rice Dewitt, AR Wednesday, September 25, 2024")}
                {renderInfoTitle("Comparing up to 5 Seperate Days | Rise of 3 Degrees Fahrenheit or More is Yellow | Drop of 3 Degrees Fahrenheit or More is Green")}
                {renderDataHeader(testHeaderData)}
                {renderGroupBox("Bin 313")}
                {renderGroupData(testGroupData)}
                {renderGroupData(testGroupData)}
                {renderGroupData(testGroupData)}
                {renderGroupData(testGroupData)}
                {renderGroupData(testGroupData)}
            </MuiMaterials.Box>
        </div>
    );
}
export default ReportTemparatureComparison;